import { Button } from '@cian/ui-kit';
import { IconProductSaveSearch16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectIsHotelSearch } from 'shared/selectors/jsonQuery';
import { selectPageType } from 'shared/selectors/page/selectPageType';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';
import { EPageType } from 'shared/types/page';
import { dispatchSaveSearchButtonClickEvent } from 'shared/utils/event';

/**
 * Кнопка сохранения поиска
 * Она тут не должна быть
 * TODO: сделать тех проект по вынесению кнопки в отдельный микрофронт (сейчас там только модалка в мкф)
 * Код можно посмотреть в мкс-потребителях: frontend-serp и map-search-frontend
 */
export const SaveSearchButtonContainer: FC = () => {
  const isHotelSearch = useSelector(selectIsHotelSearch);
  const pageType = useSelector(selectPageType);
  const isInlineFiltersRedesigned = useSelector(selectIsInlineFiltersRedesigned);
  /**
   * Редизайн-вариант кнопки — только вместе с флагом редизайна, как в FiltersContainer.
   * pageType === 'search' теперь приходит со всей выдачи (SEL-873), а не только из AB-группы
   * редизайна, и сам по себе признаком редизайна не является.
   */
  const isSearchPage = isInlineFiltersRedesigned && pageType === EPageType.SEARCH;

  if (isHotelSearch || pageType === EPageType.MAIN) {
    return null;
  }

  return isSearchPage ? (
    <Button
      theme="fill_secondary"
      size="XS"
      beforeIcon={<IconProductSaveSearch16 color="icon-main-default" />}
      onClick={dispatchSaveSearchButtonClickEvent}
    >
      Сохранить
    </Button>
  ) : (
    <Button
      theme="fill_white_primary"
      size="XS"
      beforeIcon={<IconToggleHeartOff16 color="icon-main-default" />}
      onClick={dispatchSaveSearchButtonClickEvent}
    >
      Сохранить поиск
    </Button>
  );
};
